<template>
  <input 
    @input="debounceInput" 
    type="text" 
    style="max-width:250px"
    class="no-margin"
    placeholder="Search" />
</template>

<script>
import { debounce } from 'debounce'

export default { 
  name: 'TextFilter',
  methods: {
    debounceInput: debounce(function (e) {
      const val = e.target.value
      this.$emit('filter', { key: 'text', value: val })
    }, 500)
  }
}
</script>
